import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import usePlgSelfServe from "hooks/usePlgSelfServe";
import { hasPlgSession, isPlgSetupOpen } from "plg/auth/plgTokenStore";
import { PLG_SETUP_RESUME_PATH } from "plg/utils/configSchema";
import { hasPortalSession } from "plg/auth/portalSession";
import useRecheckOnRestore from "plg/shell/useRecheckOnRestore";
import { LOGIN_ROUTE, PLG_SIGNUP_ROUTE } from "constants/routes";

/** Where a portal login is sent from the PLG app (the portal's own default landing page). */
export const PORTAL_HOME_ROUTE = "/main/dashboard";

const signedOut = () => !hasPlgSession();

function PlgRoute({ children }: { children: ReactNode }) {
  const flag = usePlgSelfServe();
  useRecheckOnRestore(signedOut, PLG_SIGNUP_ROUTE);
  if (!flag) return <Navigate to={LOGIN_ROUTE} replace />;
  // One session per browser: a portal login never opens the PLG app. If a PLG session is also
  // present, the portal's PrivateRoute ends it (the portal login wins).
  if (hasPortalSession()) return <Navigate to={PORTAL_HOME_ROUTE} replace />;
  if (!hasPlgSession()) return <Navigate to={PLG_SIGNUP_ROUTE} replace />;
  // The account exists from the first setup step; until the last one is done, the app resumes setup.
  if (isPlgSetupOpen()) return <Navigate to={PLG_SETUP_RESUME_PATH} replace />;
  return <>{children}</>;
}

export default PlgRoute;
